// extracted by mini-css-extract-plugin
export default {"regionFilter":"RegionFilter_regionFilter__TBQH1"};